/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './MobileCustomizeAccounts.scss';

import React, { Fragment } from 'react';

import MobileDefaultViewSettings from './MobileDefaultViewSettings';
import { ReactComponent as ChevronRight } from 'assets/icons/chevron-right.svg';
import MobileCustomAccountGroups from './MobileCustomAccountGroups';
import MobileAccountVisibility from './MobileAccountVisibility';
import PreferencesHeader from 'components/layouts/Preferences/PreferencesHeader';
import PreferencesSection from 'components/layouts/Preferences/shared/PreferencesSection';
import PreferencesRow from 'components/layouts/Preferences/shared/PreferencesRow';
import PreferencesCol from 'components/layouts/Preferences/shared/PreferencesCol';

class MobileCustomizeAccounts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCustomAccountGroups: false,
      showAccountVisibility: false
    };
  }

  showAccountVisibility = () => {
    this.setState({ showAccountVisibility: true });
  };

  showCustomAccountGroups = () => {
    this.setState({ showCustomAccountGroups: true });
  };

  render() {
    const { showCustomAccountGroups, showAccountVisibility } = this.state;
    const { has529Only, isBackPath, backPath } = this.props;
    return (
      <Fragment>
        {!showCustomAccountGroups && !showAccountVisibility && (
          <Fragment>
            <PreferencesHeader>
              <div className="mobile-customize-accounts-view-header">
                Customize Account View
              </div>
            </PreferencesHeader>
            <PreferencesSection fullBackground={true}>
              <div className="mobile-customize-accounts-wrapper">
                <PreferencesRow>
                  <PreferencesCol col={12}>
                    <MobileDefaultViewSettings />
                  </PreferencesCol>
                </PreferencesRow>
                {!has529Only && (
                  <PreferencesRow>
                    <PreferencesCol col={12}>
                      <MobileCustomButton
                        label="Custom Account Groups"
                        onClick={this.showCustomAccountGroups}
                      />
                    </PreferencesCol>
                  </PreferencesRow>
                )}
                <PreferencesRow>
                  <PreferencesCol col={12}>
                    <MobileCustomButton
                      label="Account Visibility"
                      onClick={this.showAccountVisibility}
                    />
                  </PreferencesCol>
                </PreferencesRow>
              </div>
            </PreferencesSection>
            {!has529Only && (
              <div className="mobile-customize-accounts-view-footer">
                <div>
                  Default Grouping setting determines the initial grouping of
                  accounts displayed on the Accounts page.
                </div>
              </div>
            )}
          </Fragment>
        )}
        {showCustomAccountGroups && !has529Only && (
          <MobileCustomAccountGroups
            isBackPath={isBackPath}
            backPath={backPath}
          />
        )}
        {showAccountVisibility && (
          <MobileAccountVisibility
            isBackPath={isBackPath}
            backPath={backPath}
          />
        )}
      </Fragment>
    );
  }
}

const MobileCustomButton = ({ label, onClick }) => {
  return (
    <button className="mobile-button" onClick={onClick}>
      <div className="row-label">
        {label}
        <span className="chevron-pull-right">
          <ChevronRight className="customize-accounts-chevron-right" />
        </span>
      </div>
    </button>
  );
};

export default MobileCustomizeAccounts;
